import { useEffect } from 'react';
import { AdvancedLink } from '@/components/astro/blog/custom-tina/advanced-link';
import Break from '@/components/astro/blog/custom-tina/break';
import { CtaBannerMd } from '@/components/astro/blog/custom-tina/cta-banner-md';
import { FreeTrialBanner } from '@/components/astro/blog/custom-tina/free-trial-banner';
import { rootLogger } from '@/lib/root-logger';

const moduleLogger = rootLogger.child({ module: 'blog-client-components' });

// Infogram embed library global type declaration
declare global {
  interface Window {
    InfogramEmbeds?: {
      initialized?: boolean;
      process?: () => void;
    };
  }
}

export const blogClientComponents = {
  CtaBannerMd,
  FreeTrialBanner,
  Break,
  AdvancedLink,
  USCityHackersEmbed1,
  USCityHackersEmbed2,
};

function USCityHackersEmbed1({ header }: { header: string }) {
  useEffect(() => {
    moduleLogger.debug({ header }, 'USCityHackersEmbed1');
    const script = document.createElement('script');
    script.src = 'https://public.flourish.studio/resources/embed.js';
    script.async = true;
    document.body.append(script);

    return () => {
      script.remove();
    };
  }, [header]);

  return (
    <div
      className='flourish-embed flourish-table'
      data-src='visualisation/19569683'
    >
      <noscript>
        <img
          alt='table visualization'
          src='https://public.flourish.studio/visualisation/19569683/thumbnail'
          width='100%'
        />
      </noscript>
    </div>
  );
}

function USCityHackersEmbed2({ header }: { header: string }) {
  useEffect(() => {
    moduleLogger.debug({ header }, 'USCityHackersEmbed2');

    // Create the script element
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';
    script.id = 'infogram-async';

    // Insert the script in the document head
    const existingScript = document.querySelector('#infogram-async');
    if (!existingScript) {
      document.body.append(script);
    }
    // Process the embed if already loaded
    if (window.InfogramEmbeds?.initialized) {
      window.InfogramEmbeds.process?.();
    }

    // Clean up the script tag if necessary
    return () => {
      if (existingScript) {
        script.remove();
      }
    };
  }, [header]);

  return (
    <>
      <div
        className='infogram-embed'
        data-id='4bfd475e-02cf-4d76-82ff-ea5eac45d057'
        data-title=''
        data-type='interactive'
      />
      <div
        style={{
          padding: '8px 0',
          fontFamily: 'Arial!important',
          fontSize: '13px!important',
          lineHeight: '15px!important',
          textAlign: 'center',
          borderTop: '1px solid #dadada',
          margin: '0 30px',
        }}
      >
        <br />
        <a
          href='https://infogram.com'
          rel='noopener nofollow noreferrer'
          style={{
            color: '#989898!important',
            textDecoration: 'none!important',
          }}
          target='_blank'
        >
          Infogram
        </a>
      </div>
    </>
  );
}
